import React, { useRef, useEffect, useState } from 'react'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'

interface Props {
  text: {}
  free: boolean
}

export const Panel = ({ text, free }: Props) => {
  const container = useRef(null)
  // const isMaximized = useRef(true)
  // const [maximized, setMaximized] = useState(true)
  const [story, setStory] = useState(null)

  // const handleScroll = () => {
  //   if (container.current.scrollTop > 20 && isMaximized.current) {
  //     console.log('Minimize')
  //     isMaximized.current = false
  //     setMaximized(false)
  //   } else if (container.current.scrollTop === 0 && !isMaximized.current) {
  //     console.log('Maximize')
  //     isMaximized.current = true
  //     setMaximized(true)
  //   }
  // }

  useEffect(() => {
    if (text) {
      setStory(
        text.text.split(/<\/?(?:div|p|br)[^>]*>\s*/im).filter(c => c.length > 5)
      )
    } else {
      setStory(null)
    }
  }, [text])

  useEffect(() => {
    // container.current.addEventListener('scroll', handleScroll)
    if (text.text) {
      setStory(
        text.text.split(/<\/?(?:div|p|br)[^>]*>\s*/im).filter(c => c.length > 5)
      )
    }

    /* return () => {
      container.current.removeEventListener('scroll', handleScroll)
    } */
  }, [])

  return (
    <div className='portrait-view-content' ref={container}>
      <div className='head-bar'>
        <div className='ui text container'>
          <div className='left'>
            <div>
              <b>{text.name}</b>
            </div>
            <div>{text.info}</div>
          </div>
          <div className='close-container'>
            <div>
              Fermer <i className='ui icon chevron right' />
            </div>
          </div>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='ui text container ta'>
          {text.name === 'En chiffres' ? (
            <>
              <h4>La vie d’infirmière en chiffres</h4>
              <p>
                Des différences de salaire par canton romand aux flux des
                travailleurs frontaliers, en passant par le taux de sortie du
                métier, les données sont variées en Suisse. Tour d'horizon.
              </p>
              <div className='dw-container'>
                <h4>Total d’infirmières et infirmiers</h4>
                <p>
                  <b>90'216</b> infirmières en Suisse, au 31 décembre 2019
                  (Comprenant: hôpitaux, EMS, services d’aide et de soins à
                  domicile)
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/WBXXa'
                />
                <p>
                  <small>
                    Il y a une infime évolution du nombre d’hommes sur les trois
                    dernières années (+0,2%).
                  </small>
                </p>
              </div>
              <div className='dw-container'>
                <h4>Les salaires bruts dans les cantons romands</h4>
                <p>
                  Salaire brut mensuel d’une infirmière travaillant dans un
                  hôpital public (formation HES, niveau bachelor). 5721
                  fr./mois, C’est le salaire brut moyen d’une infirmière en
                  hôpital en Suisse. (comprenant aussi le personnel soignant
                  intermédiaire)
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/0mne8'
                />
                <p style={{ marginTop: '1rem' }}>
                  <small>
                    <b>Fribourg et Vaud</b>: selon grille salariale du personnel
                    de l’état. <b>Genève</b>: selon l’échelle des traitements de
                    l’Office du personnel de Genève. <b>Valais</b>: selon grille
                    salariale du personnel dans les fonctions soignantes de
                    l’Hôpital du Valais. <b>Neuchâtel</b>: selon grille
                    salariale prévue pour toutes les institutions publiques de
                    l’état. <b>Jura</b>: selon grille salariale du personnel de
                    l’Hôpital du Jura. (Les salaires varient considérablement si
                    l’on est dans un EMS privé ou aux soins à domicile.)
                  </small>
                </p>
              </div>
              <div className='dw-container'>
                <h4>Flux de professionnels des soins étrangers</h4>
                <p>Personnel entrant en Suisse, flux migratoires en 2019</p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/aQmVd'
                />
                <p style={{ marginTop: '1rem' }}>
                  <small>
                    Il s’agit des infirmières diplômées, en pédiatrie, en
                    psychiatrie, du niveau tertiaire, quel que soit le secteur
                    ou le taux d’emploi, titulaires du permis G de frontalier.
                    L’OBSAN dispose uniquement d’informations sur les flux, avec
                    la difficulté d’interprétation liée au fait qu’un permis
                    frontalier a une validité maximale de 5 ans mais que, dans
                    les faits, on ignore combien de temps ces travailleurs
                    restent en Suisse.
                  </small>
                </p>
              </div>
              <div className='dw-container'>
                <h4>Densité du personnel soignant des hôpitaux suisses</h4>
                <p>
                  Emplois à plein temps pour 1000 habitants. La moyenne suisse
                  se situe à 5,5.
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/zsmx0'
                />
              </div>
              <div className='dw-container'>
                <h4>Sortie de la profession</h4>
                <p>
                  En 2016, l’Observatoire suisse de la santé (OBSAN) a présenté
                  un document offrant une vue d’ensemble de l’activité
                  professionnelle du personnel de santé en Suisse. L’étude porte
                  aussi bien sur les personnes formées dans le pays que sur
                  celles formées à l’étranger. Elle montre qu’un tiers du
                  personnel soignant de moins de 35 ans ne travaille pas (ou
                  plus) dans les services de santé. Cette proportion monte à
                  plus de 50% chez les plus de 50 ans.
                </p>
                <p>
                  <b>45,9%</b> des personnes qui résident en Suisse et qui ont
                  une formation d’infirmier/ère n’exercent pas leur profession
                  dans le système de santé.
                </p>
                <p>
                  <b>Les raisons</b>
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/83BiT'
                />
                <p>
                  <b>Selon l'âge</b>
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/32VeP'
                />
                <p>
                  <b>Selon le sexe</b>
                </p>
                <AutofitIFrame
                  aria-label='Interactive line chart'
                  src='https://datawrapper.dwcdn.net/rtC57'
                />
                <p>
                  <small>
                    La différence tient surtout au fait que les hommes sortent
                    moins fréquemment de la vie professionnelle que les femmes.
                    Ces analyses s’appuient sur les données du relevé structurel
                    de l’OFS. Il s’agit d’une enquête par échantillonnage
                    réalisée auprès d’environ 200'000 personnes.
                  </small>
                </p>
              </div>
              <div className='dw-container'>
                <p>
                  <small>
                    Infographies: Océane Haenni - Sources: OBSAN, OFS,
                    administrations et hôpitaux cantonaux, ASI (Association
                    Suisse des infirmiers/ères)
                  </small>
                </p>
              </div>
            </>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: text.text }} />
          )}
        </div>
      </div>
    </div>
  )
}
